var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-col',{staticClass:"summary",attrs:{"cols":"12","sm":"6"}},[_c('label',{staticClass:"summary-label",class:{'error--text': _vm.validator.$invalid }},[_vm._v(_vm._s(_vm.summaryLabel))]),_c('span',{staticClass:"summary-text"},[_vm._v(_vm._s(_vm.summaryText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }